// Fetch a project's Projekt-Karte when the create flow mounts. Resolves to a
// `CodeMapState` the flow reads to decide panel / free-text / skip. Any failure
// (network, 401, malformed body, broken tree) degrades to `error` → the
// free-text location question, so a flaky map fetch never blocks issue create.

import { useEffect, useState } from "react";

import { projectCodeMapResponseSchema } from "@loom/shared/code-map";

import { httpGet } from "../lib/http";

import { codeMapStateFromResponse, type CodeMapState } from "./projektKarte";

export const useProjectCodeMap = (projectId: number): CodeMapState => {
  const [state, setState] = useState<CodeMapState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading" });
    httpGet(`/api/projects/${projectId}/code-map`, projectCodeMapResponseSchema)
      .then((res) => {
        if (!cancelled) setState(codeMapStateFromResponse(res));
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return state;
};
